customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        (super(), (this.originalButtonText = ""), (this.persistentTextActive = !1));
      }
      connectedCallback() {
        setTimeout(() => {
          if (((this.form = this.querySelector("form")), !this.form)) return;
          const t = this.variantIdInput;
          if (
            (t && (t.disabled = !1),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            this.submitButton)
          ) {
            if (
              ((this.submitButtonText = this.submitButton.querySelector(".button-text")),
              this.submitButtonText &&
                ((this.originalButtonText = this.submitButtonText.textContent),
                (this.submitButton.dataset.originalText = this.originalButtonText)),
              "true" === this.submitButton.dataset.textOverride && this.submitButtonText)
            ) {
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            } else if (this.submitButton.classList.contains("has-persistent-text") && this.submitButtonText) {
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            }
            ((this.persistentTextActive || "true" === this.submitButton.dataset.textOverride) &&
              this.submitButtonText &&
              this.setupButtonTextObserver(),
              document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors),
              document.addEventListener("variant:change", this.handleVariantChange.bind(this)));
          }
        }, 100);
      }
      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
          if (!e) return;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            const currentText = this.submitButtonText.textContent.trim();
            const persistentText = e.trim();
            if (showPrice) {
              if (!currentText.startsWith(persistentText)) {
                this.submitButtonText.textContent = e;
              }
            } else {
              if (currentText !== persistentText) {
                this.submitButtonText.textContent = e;
              }
            }
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }
      handleVariantChange(t) {
        this.submitButtonText &&
          setTimeout(() => {
            if (this.persistentTextActive) {
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              if (!showPrice) {
                const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
                t && (this.submitButtonText.textContent = t);
              }
            }
          }, 50);
      }
      onSubmitHandler(t) {
        if (!this.submitButton) return;
        t.preventDefault();
        if ("true" === this.submitButton.getAttribute("aria-disabled")) return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const hasItems = this.form.querySelector('input[name^="items["][name$="][id]"]');
        let req;
        let mainIdForResponse = null;

        if (hasItems) {
          const items = [];
          const mainIdEl = this.form.querySelector('[name="id"]:not(.premium-kit-free-gift-id)');
          const mainQtyEl = this.form.querySelector('input[name="quantity"]:not([name*="items"])');
          const mainId = mainIdEl ? parseInt(mainIdEl.value) : 0;
          const mainQty = mainQtyEl ? (parseInt(mainQtyEl.value) || 1) : 1;
          if (mainId) {
            items.push({ id: mainId, quantity: mainQty });
            mainIdForResponse = mainId;
          }
          const itemMap = {};
          this.form.querySelectorAll('input[name^="items["]').forEach((input) => {
            const m = input.name.match(/^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?/);
            if (!m) return;
            const idx = m[1];
            const key = m[2];
            const sub = m[3];
            itemMap[idx] = itemMap[idx] || {};
            if (sub === undefined) {
              if (key === "id") itemMap[idx].id = parseInt(input.value);
              else if (key === "quantity") itemMap[idx].quantity = parseInt(input.value);
              else itemMap[idx][key] = input.value;
            } else if (key === "properties") {
              itemMap[idx].properties = itemMap[idx].properties || {};
              itemMap[idx].properties[sub] = input.value;
            }
          });
          Object.keys(itemMap).sort((a, b) => +a - +b).forEach((k) => {
            const obj = itemMap[k];
            if (obj.id) {
              if (!obj.quantity) obj.quantity = 1;
              items.push(obj);
            }
          });
          const payload = { items };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((s) => s.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          req = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(payload),
          };
        } else {
          req = fetchConfig("javascript");
          req.headers["X-Requested-With"] = "XMLHttpRequest";
          delete req.headers["Content-Type"];
          const fd = new FormData(this.form);
          if (this.cart) {
            fd.append("sections", this.cart.getSectionsToRender().map((s) => s.id));
            fd.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          req.body = fd;
          mainIdForResponse = fd.get("id");
        }

        const formDataShim = { get: (k) => (k === "id" ? mainIdForResponse : null) };

        fetch(`${routes.cart_add_url}`, req)
          .then((r) => r.json())
          .then(this.handleCartResponse.bind(this, formDataShim, t))
          .catch((err) => { console.error(err); })
          .finally(this.handleSubmitFinally.bind(this, t));
      }
      handleCartResponse(formData, event, responseData) {
        if (responseData.status) {
          (publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          }),
            this.handleErrorMessage(responseData.description));
          const e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;
          return (
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButtonText && this.submitButtonText.classList.add("hidden"),
            e.classList.remove("hidden"),
            void (this.error = !0)
          );
        }
        if (!this.cart) return void (window.location = window.routes.cart_url);
        const e = CartPerformance.createStartingMarker("add:wait-for-subscribers");
        (this.error ||
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: responseData,
          }).then(() => {
            CartPerformance.measureFromMarker("add:wait-for-subscribers", e);
          }),
          (this.error = !1));
        const i = this.closest("quick-add-modal");
        i
          ? (document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(responseData);
                  });
                });
              },
              { once: !0 },
            ),
            i.hide(!0))
          : CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(responseData);
            });
      }
      handleSubmitFinally(event) {
        this.submitButton.classList.remove("loading");
        this.submitButton.removeAttribute("aria-disabled");
        if (this.cart) this.cart.classList.remove("is-empty");
        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.add("hidden");
        if (!this.error && this.persistentTextActive) {
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
          if (t && this.submitButtonText) {
            if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
              this.submitButtonText.textContent = t;
            }
          }
        }
        CartPerformance.measureFromEvent("add:user-action", event);
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      toggleSubmitButton(t = !0, e) {
        if (t) (this.submitButton.setAttribute("disabled", "disabled"), e && (this.submitButtonText.textContent = e));
        else {
          if ((this.submitButton.removeAttribute("disabled"), "true" === this.submitButton.dataset.textOverride));
          else if (this.persistentTextActive) {
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t) return void (this.submitButtonText.textContent = t);
          }
          this.originalButtonText
            ? (this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (this.submitButtonText.textContent = this.submitButton.dataset.originalText)
              : (this.submitButtonText.textContent = window.variantStrings.addToCart);
        }
      }
      disconnectedCallback() {
        (this.buttonTextObserver && this.buttonTextObserver.disconnect(),
          document.removeEventListener("variant:change", this.handleVariantChange));
      }
      get variantIdInput() {
        return this.form ? this.form.querySelector("[name=id]") : null;
      }
    },
  );
